import { render } from "./GenproxRadio.vue?vue&type=template&id=94bf9510&scoped=true&ts=true"
import script from "./GenproxRadio.vue?vue&type=script&lang=ts"
export * from "./GenproxRadio.vue?vue&type=script&lang=ts"

import "./GenproxRadio.vue?vue&type=style&index=0&id=94bf9510&lang=postcss&scoped=true"
/* custom blocks */
import block0 from "./GenproxRadio.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94bf9510"]])

export default __exports__